import { Loader2Icon } from 'lucide-react';
import { cn } from '@rocco/utils/cn';
import type { PartialConversation } from '../../types';
import { ChatInboxListItem } from './ChatInboxListItem';

/**
 * The chat inbox list. This is an infinite scrolling list of conversations
 * belonging to the current user.
 * @see {@link ChatInboxDrawer}
 */
export function ChatInboxList({
    className,
    conversations,
    isLoading,
}: {
    className?: string;
    conversations: PartialConversation[];
    isLoading: boolean;
}) {
    return (
        <ul className={cn('flex flex-col gap-2 overflow-y-auto', className)}>
            {isLoading ? (
                // TODO: Skeleton
                <li>
                    <Loader2Icon className="mx-auto size-12 animate-spin text-black/50" />
                </li>
            ) : (
                conversations.map((conversation) => (
                    <ChatInboxListItem
                        key={conversation.ID}
                        conversation={conversation}
                    />
                ))
            )}
        </ul>
    );
}
